<template>
  <div v-if="show">
    <loading :loading="loading"></loading>
    <div class="dropdown_container">
      <wxc-dropdown
          title="Document Type"
          default-item="Select"
          :config="dropdownConfig"
          :list="clientIdentifierDocumentList"
          :select-item="clientIdentifierDocument"
          @onItemSelected="onClientIdentifierDocumentSelected($event.value)"
      ></wxc-dropdown>
    </div>

    <!-- Dummy pan image show only when pan is updalod 
      TODO - Show pan image
    -->
    <div v-if="false">
      <weex-image
        v-if="dummyPanCardImageURL"
        class="horizontal_center"
        :src="dummyPanCardImageURL"
        style="width: 200px;"
      ></weex-image>
    </div>

    <file-attach-button v-if="showFileUploadButton"
        v-show="needToShowClientIdentifierUploadButton"
        class="margin-top-20"
        ref="upload_document"
        file-attach-button-id="upload_document"
        text="Upload Document"
        size="full"
        :attach-image-des-src="attachImageSrc"
        :disabled="true"
        :disabled-button-style="attachButtonStyle"
        :disable-text-style="attachButtonTextStyle"
        @attachFilesClicked="onAttachFrontPageClicked"
        @filesAttached="onClientIdentifierAttached($event.files[0])"
    ></file-attach-button>

    <weex-text v-if="showFileUploadButton"
      class="margin-top-20 item-sm-description text-color-gray">
      -OR-
    </weex-text>

    <wxc-button
        text="Enter Details Manually"
        class="horizontal-center margin-top-20"
        type="blue"
        @wxcButtonClicked="enterDetailsManually"
    ></wxc-button>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown/index";
import Loading from "./Loading";
import ErrorAlertItem from "./ErrorAlertItem";
import AlertService from "../core/alert/AlertService";
import {MessageConstants} from "../../utils/MessageConstantUtil";
import PrefManager from "../../data/model/PrefManager";
import {DefaultResourceConfig, ImageResourcesUtil} from "../../utils/ImageResourcesUtil";
import FileAttachButton from "@/components/layout/FileAttachButton";
import EzUtils from "../../utils/EzUtils";
import { Constants } from "../../components/Constants";
import DataSource from "../../data/DataSource";

export default {
  name: "ChooseClientIdentifierDocumentItem",
  components: {
    WxcButton,
    WxcDropdown,
    Loading,
    ErrorAlertItem,
    FileAttachButton
  },

  data: () => ({
    loading : false,
    networkError: {},
    clientIdentifierDocument: "",
    clientIdentifierDocumentList: [],
    panOCRData : {}
  }),

  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    onClientIdentifierDocumentSelected(clientIdentifierDocument) {
      this.clientIdentifierDocument = clientIdentifierDocument;
    },

    onAttachFrontPageClicked() {
      if (this.checkForValidation()) {
        this.$refs.upload_document.attachFile();
      }
    },

    onClientIdentifierAttached(file) {
      this.loading = true;
      DataSource.getPanOcrData(file)
      .then(ocrRes => {
        this.loading = false;
        if (!ocrRes.errorOccurred) {
          this.panOCRData = ocrRes.data;
        }
        this.enterDetailsManually();
      })
    },

    setDocumentTypes() {
      const retailerConfig = PrefManager.getRetailerConfig();
      if (retailerConfig && retailerConfig.individualDocumentTypes && retailerConfig.individualDocumentTypes.length > 0) {
        retailerConfig.individualDocumentTypes.forEach(documentType => {
          this.clientIdentifierDocumentList.push({title:  EzUtils.removeUnderscoreFromString(documentType, ["PAN", "ID"]), value: documentType});
        })
      } else {
        this.clientIdentifierDocumentList.push({title: "PAN", value: "PAN"});
      }

      if (this.clientIdentifierDocumentList.length === 1) {
        this.clientIdentifierDocument = this.clientIdentifierDocumentList[0].value
      }
    },

    enterDetailsManually() {
      if (this.checkForValidation()) {
        this.$emit("enterDetailsManually", this.clientIdentifierDocument, this.panOCRData);
      }
    },

    checkForValidation() {
      if (!this.clientIdentifierDocument) {
        this.showToast(MessageConstants.SELECT_DOCUMENT_TYPE);
        return false;
      }
      return true;
    }
  },

  mounted() {
    this.setDocumentTypes();
  },

  computed: {
    showFileUploadButton() {
      return Constants.PAN === this.clientIdentifierDocument;
    },

    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },

    needToShowClientIdentifierUploadButton() {
      return true;
    },

    attachImageSrc() {
      return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
    },

    attachButtonStyle() {
      return {
        backgroundColor: "#ffffff",
        "border-width": "1px",
        "border-color": "#B5B5B5",
        "border-style": "solid"
      };
    },

    attachButtonTextStyle() {
      return {color: "#000000", "font-weight": "bold"};
    },

    dummyPanCardImageURL(){
       return ImageResourcesUtil.getImageLink(ImageResourcesUtil.PAN_TEMPLATE)
    },
  }
}
</script>


<style
    scoped
    src="../../assets/style/base.css"></style>
